"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nutrition = void 0;
var common_1 = require("../../../common");
var Nutrition = /** @class */ (function (_super) {
    __extends(Nutrition, _super);
    function Nutrition(props) {
        if (props === void 0) { props = {}; }
        return _super.call(this, __assign(__assign({}, Nutrition.defaultProps()), props)) || this;
    }
    /**
     * @deprecated use a conversion library
     */
    Nutrition.lbsToKg = function (lbs) {
        return lbs * 2.2046226218;
    };
    /**
     * @deprecated use a conversion library
     */
    Nutrition.kgToLbs = function (kg) {
        return kg * 0.453592;
    };
    Nutrition.defaultProps = function () {
        return {
            foodFlavors: [],
            ingredients: [],
            caloricContent: {
                kcalPerKg: null,
                kcalPerLbs: null,
                kcalPerCup: null
            },
            analysis: {
                crudeProtein: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                crudeFat: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                crudeFiber: {
                    value: null,
                    measurement: '%',
                    suffix: 'max'
                },
                moisture: {
                    value: null,
                    measurement: '%',
                    suffix: 'max'
                },
                dha: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                choline: {
                    value: null,
                    measurement: 'mg/kg',
                    suffix: 'min'
                },
                ara: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                lCarnitine: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                calcium: {
                    value: null,
                    measurement: 'mg/kg',
                    suffix: 'min'
                },
                zinc: {
                    value: null,
                    measurement: 'mg/kg',
                    suffix: 'min'
                },
                phosphorus: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                selenium: {
                    value: null,
                    measurement: 'mg/kg',
                    suffix: 'min'
                },
                vitaminE: {
                    value: null,
                    measurement: 'IU/kg',
                    suffix: 'min'
                },
                vitaminA: {
                    value: null,
                    measurement: 'IU/kg',
                    suffix: 'min'
                },
                vitaminC: {
                    value: null,
                    measurement: 'IU/kg',
                    suffix: 'min'
                },
                ascorbicAcid: {
                    value: null,
                    measurement: 'IU/kg',
                    suffix: 'min'
                },
                omega3FattyAcids: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                omega6FattyAcids: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                docosahexaenoicAcid: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                linoleicAcid: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                eicosapentaenoicAcid: {
                    value: null,
                    measurement: '%',
                    suffix: 'min'
                },
                glucosamine: {
                    value: null,
                    measurement: 'ppm',
                    suffix: 'min'
                }
            }
        };
    };
    return Nutrition;
}(common_1.AbstractModelLight));
exports.Nutrition = Nutrition;
